import { PlanningEvent } from "@ui/components/ui/planning";
import { ActivitySearchBar } from "@ui/components/ui/planning/ActivitySearchBar";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@ui/components/ui/Select";

interface FiltersBarsProps {
  slots: PlanningEvent[];
  onOpenActivitiesDetails?: (events: PlanningEvent[]) => void;
  placeNames?: string[];
  setPlaceFilter: (place: string | undefined) => void;
}

export function FiltersBars({
  slots,
  onOpenActivitiesDetails,
  placeNames,
  setPlaceFilter,
}: FiltersBarsProps) {
  return (
    <div className="flex w-fit flex-row items-center gap-2">
      {onOpenActivitiesDetails !== undefined ? (
        <ActivitySearchBar
          slots={slots}
          openActivityDetails={(id) =>
            onOpenActivitiesDetails?.(slots.filter((s) => s.activityId === id))
          }
        />
      ) : null}
      <Select
        onValueChange={(value) =>
          setPlaceFilter(value === "all" ? undefined : value)
        }
      >
        <SelectTrigger className="h-[41px] w-fit grow px-4">
          <SelectValue placeholder="Sélectionner un lieu" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem key={undefined} value={"all"}>
            Tous les lieux
          </SelectItem>
          {placeNames &&
            placeNames.map((place) => (
              <SelectItem key={place} value={place}>
                {place}
              </SelectItem>
            ))}
        </SelectContent>
      </Select>
    </div>
  );
}
